export const OPTIONS = [
    { label: "All", value: "all" },
    { label: "Single", value: "normal" },
    { label: "Parlay", value: "step" },
    { label: "Combo", value: "comboStep" },
  ];
  